var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-progress"},[_c('van-image',{attrs:{"width":"130","height":"130","round":"","fit":"cover","src":require('@/assets/logo.png')}}),_c('van-loading',{attrs:{"color":"#40c057"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }